/* eslint-disable no-trailing-spaces */
/* eslint-disable indent */
/** 当路由表太长时，可以将其拆分为小模块 **/

import Layout from '@/layout'

const marketRouter = {
  path: '/market',
  component: Layout,
  redirect: 'noRedirect',
  name: 'market',
  // hidden: true,
  meta: {
    title: '扫码营销系统',
    icon: 'tree-table',
     roles: ['market']
  },
  children: [
    // 营销模块
    {
      path: 'marketing',
      component: () => import('@/views/market/first'),
      name: 'marketing',
      redirect: 'noRedirect',
      meta: { title: '营销管理', roles: ['marketing'] },
      children: [
            {
              path: '/activitylist',
              component: () => import('@/views/market/marketing/promotion/activitylist/activitylist'),
              name: 'activitylist',
              meta: { title: '活动列表', roles: ['activitylist'] }
            },
            {
              path: '/activityset',
              component: () => import('@/views/home/third'),
              name: 'activityset',
              meta: { title: '活动设置', roles: ['activityset'] },
              children:[
                {
                  path: '/consumerpolicy',
                  component: () => import('@/views/market/marketing/promotion/consumerpolicy/consumerpolicy'),
                  name: 'consumerpolicy',
                  meta: { title: '消费者活动', roles: ['consumerpolicy'] }
                },
                {
                  path: '/distributorpolicy',
                  component: () => import('@/views/market/marketing/promotion/distributorpolicy/distributorpolicy'),
                  name: 'distributorpolicy',
                  meta: { title: '分销商活动', roles: ['distributorpolicy'] }
                },
              ]
            },
            {
              path: '/promotionrule',
              component: () => import('@/views/market/marketing/promotion/promotionrule/promotionrule'),
              name: 'promotionrule',
              meta: { title: '活动模板', roles: ['promotionrule'] },
            },
        // {
        //   path: 'pointreward',
        //   component: () => import('@/views/home/second'),
        //   name: 'pointreward',
        //   redirect: 'noRedirect',
        //   meta: { title: '积分商城管理' },
        //   children: [
        //     {
        //       path: '/commoditymanage',
        //       component: () => import('@/views/market/marketing/pointreward/commoditymanage/commoditymanage'),
        //       name: 'commoditymanage',
        //       meta: { title: '商品管理', roles: ['commoditymanage'] }
        //     },
        //     {
        //       path: '/exchangeaudit',
        //       component: () => import('@/views/market/marketing/pointreward/exchangeaudit/exchangeaudit'),
        //       name: 'exchangeaudit',
        //       meta: { title: '商品兑换审核', roles: ['exchangeaudit'] }
        //     },
        //     {
        //       path: '/integralparameter',
        //       component: () => import('@/views/market/marketing/pointreward/integralparameter/integralparameter'),
        //       name: 'integralparameter',
        //       meta: { title: '配置积分参数', roles: ['integralparameter'] }
        //     }
        //   ]
        // }
      ]
    },
    {
      path: '/prize',
      component: () => import('@/views/home/first'),
      name: 'prize',
      meta: { title: '奖品管理', roles: ['prize'] },
      children :[
        // {
        //   path: '/prizemanage',
        //   component: () => import('@/views/market/marketing/promotion/prizemanage/prizemanage'),
        //   name: 'prizemanage',
        //   meta: { title: '奖品管理', roles: ['prizemanage'] }
        // },
        {
          path: '/prizeredpacket',
          component: () => import('@/views/market/marketing/promotion/prizeredpacket/prizeredpacket'),
          name: 'prizeredpacket',
          meta: { title: '红包奖品', roles: ['prizeredpacket'] }
        },
        {
          path: '/prizeintegral',
          component: () => import('@/views/market/marketing/promotion/prizeintegral/prizeintegral'),
          name: 'prizeintegral',
          meta: { title: '积分奖品', roles: ['prizeintegral'] }
        },
        {
          path: '/prizeentity',
          component: () => import('@/views/market/marketing/promotion/prizeentity/prizeentity'),
          name: 'prizeentity',
          meta: { title: '实物奖品', roles: ['prizeentity'] }
        },
        {
          path: '/prizecoupon',
          component: () => import('@/views/market/marketing/promotion/prizecoupon/prizecoupon'),
          name: 'prizecoupon',
          meta: { title: '电子券奖品', roles: ['prizecoupon'] }
        }
      ]
    },
    {
      path: 'viprecord',
      component: () => import('@/views/market/first'),
      name: 'viprecord',
      redirect: 'noRedirect',
      meta: { title: '会员记录', roles: ['viprecord'] },
      children: [
        {
          path: '/customer',
          component: () => import('@/views/home/second'),
          name: 'customer',
          redirect: 'noRedirect',
          meta: { title: '消费者', roles: ['customer'] },
          children: [
            {
              path: '/customerlist',
              component: () => import('@/views/market/viprecord/customer/customerlist'),
              name: 'customerlist',
              meta: { title: '会员信息', roles: ['customerlist'] }
            },
            {
              path: '/customerrecord',
              component: () => import('@/views/market/viprecord/customer/customerrecord'),
              name: 'customerrecord',
              meta: { title: '扫码记录', roles: ['scancode'] }
            },
            {
              path: '/customercount',
              component: () => import('@/views/market/viprecord/customer/customercount'),
              name: 'customercount',
              meta: { title: '奖励排行', roles: ['customercount'] }
            }
          ]
        },
        {
          path: '/terminal',
          component: () => import('@/views/home/second'),
          name: 'terminal',
          redirect: 'noRedirect',
          meta: { title: '终端/厨师长', roles: ['terminal'] },
          children: [
            {
              path: '/terminallist',
              component: () => import('@/views/market/viprecord/terminal/terminallist'),
              name: 'terminallist',
              meta: { title: '终端信息', roles: ['terminallist'] }
            },
            {
              path: '/conversionrecord',
              component: () => import('@/views/market/viprecord/terminal/conversionrecord'),
              name: 'conversionrecord',
              meta: { title: '积分记录', roles: ['scancode'] }
            },
            {
              path: '/referrerlist',
              component: () => import('@/views/market/viprecord/terminal/referrerlist'),
              name: 'referrerlist',
              meta: { title: '推荐人信息', roles: ['referrerlist'] }
            },
            {
              path: '/terminalcount',
              component: () => import('@/views/market/viprecord/terminal/terminalcount'),
              name: 'terminalcount',
              meta: { title: '厨师长排行', roles: ['terminalcount'] }
            }
          ]
        },
        {
          path: '/distributor',
          component: () => import('@/views/home/second'),
          name: 'distributor',
          redirect: 'noRedirect',
          meta: { title: '分销商', roles: ['distributor'] },
          children: [
            {
              path: '/distributorlist',
              component: () => import('@/views/market/viprecord/distributor/distributorlist'),
              name: 'distributorlist',
              meta: { title: '分销商信息', roles: ['distributorlist'] }
            },
            {
              path: '/distributorrecord',
              component: () => import('@/views/market/viprecord/distributor/distributorrecord'),
              name: 'distributorrecord',
              meta: { title: '扫码记录', roles: ['distributorrecord'] }
            },
            {
              path: '/distributorcount',
              component: () => import('@/views/market/viprecord/distributor/distributorcount'),
              name: 'distributorcount',
              meta: { title: '奖励排行', roles: ['distributorcount'] }
            }
          ]
        },
      ]
    },
    {
      path: 'channel',
      component: () => import('@/views/market/first'),
      name: 'channel',
      redirect: 'noRedirect',
      meta: { title: '渠道管理', roles: ['channel'] },
      children: [
        {
          path: 'dealermanage',
          component: () => import('@/views/market/channel/dealermanage/dealermanage'),
          name: 'dealermanage',
          meta: { title: '经销商管理', roles: ['dealermanage'] },
          children: [
          ]
        },
        {
          path: 'terminalmanage',
          component: () => import('@/views/market/channel/terminalmanage/terminalmanage'),
          name: 'terminalmanage',
          meta: { title: '终端管理', roles: ['terminalmanage'] },
        },
        {
          path: 'distributor',
          component: () => import('@/views/market/second'),
          name: 'distributor',
          meta: { title: '分销商管理', roles: ['distributor'] },
          children:[
            {
              path: 'distributormanage',
              component: () => import('@/views/market/channel/distributormanage/distributormanage'),
              name: 'distributormanage',
              meta: { title: '分销商管理', roles: ['distributormanage'] }
            },
            {
              path: 'distributoraudit',
              component: () => import('@/views/market/channel/distributormanage/distributoraudit'),
              name: 'distributoraudit',
              meta: { title: '分销商审核', roles: ['distributoraudit'] }
            },
          ]
        },
        {
          path: 'channeltree',
          component: () => import('@/views/market/channel/channeltree'),
          name: 'channeltree',
          meta: { title: '渠道机构树', roles: ['channeltree'] },
        },
      ]
    },
    {
      path: 'pond',
      component: () => import('@/views/market/first'),
      name: 'pond',
      meta: { title: '奖池管理', roles: ['pond'] },
      children: [
        // {
        //   path: '/pondmanage',
        //   component: () => import('@/views/market/pond/pondmanage/pondmanage'),
        //   name: 'pondmanage',
        //   meta: { title: '奖池管理', roles: ['pondmanage'] },
        // },
        {
          path: '/paylist',
          component: () => import('@/views/market/pond/paylist'),
          name: 'paylist',
          meta: { title: '充值记录', roles: ['paylist'] },
        },
        {
          path: '/payaudit',
          component: () => import('@/views/market/pond/payaudit'),
          name: 'payaudit',
          meta: { title: '充值审核', roles: ['payaudit'] },
        },
      ]
    },
  ]
}

export default marketRouter
